import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from 'primereact/dialog';
import modalStyles from 'shared/components/modalStyles';

import {
    viewVideo
} from 'app/actions/kioskActions';

const styles = () => ({
    ...modalStyles()
});
const VideoDialog = (props) => {
    const { viewVideo, showVideoDialog, videoMoment } = props;
    return <Dialog visible={showVideoDialog} onHide={() => { viewVideo(false, null) }}>
        {
            videoMoment &&
            <video width="750" height="500" src={videoMoment.original} type={videoMoment.type} controls ></video>
        }
    </Dialog>
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    showVideoDialog: state.kioskReducer.showVideoDialog,
    videoMoment: state.kioskReducer.videoMoment
});

export default connect(mapStateToProps, { viewVideo })(withStyles(styles)(VideoDialog));